<!--
 * @Author: 罗川平 2150673512@qq.com
 * @Date: 2026-03-26 14:57:26
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2026-06-25 15:18:00
 * @FilePath: \watherfocast2\src\views\HomeView.vue
 * @Description: 首页 - 地图网格效果 + 左右两侧卡片 + 底部预测流量统计
-->
<template>
  <div class="homeViewBody">
    <div class="homeViewHeader">
      水电站精细化来水预测平台
      <div class="timeBox">
        {{ currentTime }}
      </div>
      <div class="locBox"></div>
    </div>
    <div class="myheaderBtnBox">
      <div class="myheaderBtnitem">首页</div>
      <div class="myheaderBtnitem" @click="goToStatistics">统计查询</div>
      <div class="myheaderBtnitem" @click="goToPrediction">预测分析</div>
      <div class="myheaderBtnitem user-menu" @click="handleLogout">
        <i class="el-icon-user-solid"></i>
        退出登录
      </div>
    </div>
    <div v-if="warningData" class="warning-banner" :class="'warning-' + (warningData.severity || '').toLowerCase()">
      <div class="warning-icon">
        <i class="el-icon-warning"></i>
      </div>
      <div class="warning-content">
        <div class="warning-headline">{{ warningData.headline }}</div>
        <div class="warning-desc">{{ warningData.description }}</div>
      </div>
      <div class="warning-close" @click="warningData = null">
        <i class="el-icon-close"></i>
      </div>
    </div>
    <div class="homeMainBox">
      <div v-if="pageLoading" class="loading-overlay">
        <div class="loading-spinner">
          <i class="el-icon-loading"></i>
          <p>数据加载中...</p>
        </div>
      </div>

      <div class="mainLayout">
        <div class="leftColumn">
          <div class="card">
            <dv-border-box-8>
              <div class="chart-container">
                <div class="chart-title">操作</div>
                <div class="operation-content">
                  <div class="operation-item">
                    <span class="label">水电站:</span>
                    <el-select v-if="isAdmin" v-model="adminSelectedStation" placeholder="请选择站点" style="width: 200px" @change="onAdminStationChange">
                      <el-option label="竹格多水电站" value="513201"></el-option>
                      <el-option label="二道桥水电站" value="513202"></el-option>
                      <el-option label="四板沟水电站" value="513203"></el-option>
                    </el-select>
                    <span v-else class="station-name">{{ hyStation }}</span>
                  </div>
                  <div class="operation-item">
                    <span class="label">时间:</span>
                    <el-date-picker
                      v-model="selectedDate"
                      type="date"
                      placeholder="选择日期"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      style="width: 200px"
                    >
                    </el-date-picker>
                  </div>
                  <div class="operation-item">
                    <span class="label">模型:</span>
                    <div class="radio-group" style="width: 200px;">
                       <label class="radio-label" style="width:100px">
                        <input type="radio" name="modelType" value="1" v-model="selectedModel"> 拟合模型
                      </label>
                      <label class="radio-label" style="width:100px">
                        <input type="radio" name="modelType" value="0" v-model="selectedModel"> 神经网络
                      </label>
                     
                    </div>
                  </div>
                  <div class="operation-item2">
                    <button class="confirm-btn" @click="fetchData">确认</button>
                  </div>
                  <!-- <div class="operation-item2">
                    <button class="confirm-btn green">导入</button>
                    <button class="confirm-btn green">训练</button>
                  </div> -->
                  <div class="operation-item3">
                    <button class="text-btn" @click="openFlowEntry">
                      <i class="el-icon-link"></i> 流量录入
                    </button>
                    <button class="text-btn" @click="goToIntervalFlowEntry">
                      <i class="el-icon-link"></i> 区间流量录入
                    </button>
                    <button v-if="stationId === '513201'" class="text-btn" @click="goToUpstreamFlow">
                      <i class="el-icon-link"></i> 上游流量录入
                    </button>
                  </div>
                </div>
              </div>
            </dv-border-box-8>
          </div>
          <div class="card">
            <dv-border-box-8>
              <div class="chart-container">
                <div class="chart-title">检验结果</div>
                <div class="chart-actions">
                  <button class="action-btn icon-only" @click="toggleInspectionFullscreen">
                    <i class="el-icon-full-screen"></i>
                  </button>
                </div>
                <div ref="inspectionChart" class="chart-content"></div>
              </div>
            </dv-border-box-8>
          </div>
        </div>

        <div class="centerColumn">
          <div class="card map-card">
            <dv-border-box-8>
              <div class="chart-container map-container">
                <div class="map-header-row">
                  <span class="chart-title">面雨量预测分布图</span>
                  <button class="action-btn icon-only" @click="toggleMapFullscreen">
                    <i class="el-icon-full-screen"></i>
                  </button>
                </div>
                <div ref="rainfallMap" id="homeMap" class="map-chart"></div>
                <div class="map-opacity-slider">
                  <span class="opacity-label">格点透明度</span>
                  <input
                    type="range"
                    min="30"
                    max="255"
                    :value="gridOpacity"
                    @input="updateGridOpacity"
                    class="opacity-range"
                  />
                  <span class="opacity-value">{{ Math.round(gridOpacity / 255 * 100) }}%</span>
                </div>
              </div>
            </dv-border-box-8>
          </div>
          <div class="card">
            <dv-border-box-8>
              <div class="chart-container">
                <div class="chart-title">预测流量统计</div>
                <div class="chart-actions">
                  <button class="action-btn icon-only" @click="toggleDailyFullscreen">
                    <i class="el-icon-full-screen"></i>
                  </button>
                  <button class="action-btn" @click="downloadDailyChart">下载图片</button>
                  <button class="action-btn" @click="toggleDailyTable">{{ showDailyTable ? '图表显示' : '表格显示' }}</button>
                </div>
                <div v-show="!showDailyTable" ref="dailyChart" class="chart-content"></div>
                <div v-if="showDailyTable" class="table-content">
                  <table>
                    <thead>
                      <tr>
                        <th>日期</th>
                        <th>逐日流量(m³/s)</th>
                        <th>区间流量(m³/s)</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in dailyTableData" :key="index">
                        <td>{{ item.daytime.substring(5, 10) }}</td>
                        <td>{{ item.dayPredictPredictTraffic || 0 }}</td>
                        <td>{{ ((item.dayPredictPredictTraffic || 0) / 2).toFixed(2) }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </dv-border-box-8>
          </div>
        </div>

        <div class="rightColumn">
          <div class="card">
            <dv-border-box-8>
              <div class="chart-container">
                <div class="chart-actions">
                  <button class="action-btn icon-only" @click="toggleRainfallFullscreen">
                    <i class="el-icon-full-screen"></i>
                  </button>
                </div>
                <div class="radio-group">
                  <label class="radio-label">
                    <input type="radio" name="dataMode" value="flow" v-model="currentDataMode"> 流量数据
                  </label>
                  <label class="radio-label">
                    <input type="radio" name="dataMode" value="daily" v-model="currentDataMode"> 逐日雨量
                  </label>
                  <label class="radio-label">
                    <input type="radio" name="dataMode" value="hourly" v-model="currentDataMode"> 面雨量
                  </label>
                </div>
                <div ref="rainfallChart" class="chart-content"></div>
              </div>
            </dv-border-box-8>
          </div>
          <div class="card">
            <dv-border-box-8>
              <div class="chart-container">
                <div class="chart-title">实际与预测对比</div>
                <div class="chart-actions">
                  <button class="action-btn icon-only" @click="toggleComparisonFullscreen">
                    <i class="el-icon-full-screen"></i>
                  </button>
                </div>
                <div ref="comparisonChart" class="chart-content"></div>
              </div>
            </dv-border-box-8>
          </div>
        </div>
      </div>
    </div>
    <div v-if="comparisonFullscreen" class="fullscreen-overlay" @click.self="toggleComparisonFullscreen">
      <div class="fullscreen-chart-container">
        <div class="fullscreen-header">
          <span class="fullscreen-title">实际与预测对比</span>
          <button class="fullscreen-close-btn" @click="toggleComparisonFullscreen">
            <i class="el-icon-close"></i> 关闭
          </button>
        </div>
        <div ref="comparisonFullscreenChart" class="fullscreen-chart-content"></div>
      </div>
    </div>
    <div v-if="rainfallFullscreen" class="fullscreen-overlay" @click.self="toggleRainfallFullscreen">
      <div class="fullscreen-chart-container">
        <div class="fullscreen-header">
          <span class="fullscreen-title">{{ rainfallFullscreenTitle }}</span>
          <button class="fullscreen-close-btn" @click="toggleRainfallFullscreen">
            <i class="el-icon-close"></i> 关闭
          </button>
        </div>
        <div ref="rainfallFullscreenChart" class="fullscreen-chart-content"></div>
      </div>
    </div>
    <div v-if="inspectionFullscreen" class="fullscreen-overlay" @click.self="toggleInspectionFullscreen">
      <div class="fullscreen-chart-container">
        <div class="fullscreen-header">
          <span class="fullscreen-title">检验结果</span>
          <button class="fullscreen-close-btn" @click="toggleInspectionFullscreen">
            <i class="el-icon-close"></i> 关闭
          </button>
        </div>
        <div ref="inspectionFullscreenChart" class="fullscreen-chart-content"></div>
      </div>
    </div>
    <div v-if="mapFullscreen" class="fullscreen-overlay">
      <div class="fullscreen-map-container">
        <div class="fullscreen-header">
          <span class="fullscreen-title">面雨量预测分布图</span>
          <button class="fullscreen-close-btn" @click="toggleMapFullscreen">
            <i class="el-icon-close"></i> 关闭
          </button>
        </div>
        <div ref="mapFullscreenContainer" class="fullscreen-map-content"></div>
      </div>
    </div>
    <div v-if="dailyFullscreen" class="fullscreen-overlay" @click.self="toggleDailyFullscreen">
      <div class="fullscreen-chart-container">
        <div class="fullscreen-header">
          <span class="fullscreen-title">预测流量统计</span>
          <button class="fullscreen-close-btn" @click="toggleDailyFullscreen">
            <i class="el-icon-close"></i> 关闭
          </button>
        </div>
        <div ref="dailyFullscreenChart" class="fullscreen-chart-content"></div>
      </div>
    </div>
    <div class="copyright-footer">@2026 成都科达乐科技有限公司联合四川省气象局联合开发</div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import axios from 'axios'
import * as L from 'leaflet'
import { MapCreate, legendColor } from '../map/mapImport.js'
import rodjosn from '../map/shuixi.json'
import stationIcon from '../assets/shuidian.png'

export default {
  name: 'HomeView',
  data() {
    return {
      comparisonChartInstance: null,
      comparisonFullscreenChartInstance: null,
      comparisonFullscreen: false,
      dailyChartInstance: null,
      dailyFullscreenChartInstance: null,
      dailyFullscreen: false,
      inspectionChartInstance: null,
      inspectionFullscreenChartInstance: null,
      inspectionFullscreen: false,
      rainfallChartInstance: null,
      rainfallFullscreenChartInstance: null,
      rainfallFullscreen: false,
      currentDataMode: 'flow',
      currentTime: '',
      hyStation: localStorage.getItem('hyStation') || '竹格多水电站',
      stationId: localStorage.getItem('stationId') || '',
      adminSelectedStation: '513201',
      selectedDate: '2026-03-29 00:00:00',
      selectedModel: '1',
      apiBaseURL: 'https://moodsci.com/lsserver/api/hydro/InspectionDayHourResults?date=2026-03-22 00:00:00',
      currentDayRainData: [],
      currentHourRainData: [],
      currentDayRealRainData: [],
      comparisonData: {
        dates: [],
        actual: [],
        predicted: [],
        actualFlow: [],
        predictedName: '预测流量',
        actualName: '实际流量'
      },
      showDailyTable: false,
      dailyTableData: [],
      pageLoading: false,
      warningData: null,
      mapData: null,
      mapFullscreen: false,
      mapFullscreenInstance: null,
      gridDataLayer: null,
      gridLinesLayer: null,
      gridValuesLayer: null,
      gridLegend: null,
      gridOpacity: 230,
      gridDataCache: null,
      gridListCache: null,
      stationMarkersLayer: null,
      drainLayer: null
    }
  },
  mounted() {
    this.selectedDate = this.getYesterday()
    this.updateTime()
    this.initComparisonChart()
    this.initDailyChart()
    this.initInspectionChart()
    this.initRainfallChart()
    this.initMap()
    this.fetchData()
    this.fetchWarning()
    window.addEventListener('resize', this.handleResize)
    setInterval(() => {
      this.updateTime()
    }, 1000)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
    if (this.comparisonChartInstance) {
      this.comparisonChartInstance.dispose()
    }
    if (this.comparisonFullscreenChartInstance) {
      this.comparisonFullscreenChartInstance.dispose()
    }
    if (this.dailyChartInstance) {
      this.dailyChartInstance.dispose()
    }
    if (this.dailyFullscreenChartInstance) {
      this.dailyFullscreenChartInstance.dispose()
    }
    if (this.inspectionChartInstance) {
      this.inspectionChartInstance.dispose()
    }
    if (this.inspectionFullscreenChartInstance) {
      this.inspectionFullscreenChartInstance.dispose()
    }
    if (this.rainfallChartInstance) {
      this.rainfallChartInstance.dispose()
    }
    if (this.rainfallFullscreenChartInstance) {
      this.rainfallFullscreenChartInstance.dispose()
    }
    if (this.mapFullscreenInstance && this.mapFullscreenInstance.map) {
      this.mapFullscreenInstance.map.remove()
      this.mapFullscreenInstance = null
    }
    this.clearGridData()
  },
  computed: {
    isAdmin() {
      return this.stationId === '10000'
    },
    effectiveStationId() {
      return this.isAdmin ? this.adminSelectedStation : this.stationId
    },
    rainfallFullscreenTitle() {
      const titles = { flow: '流量数据', daily: '逐日雨量', hourly: '面雨量' }
      return titles[this.currentDataMode] || '雨量数据'
    }
  },
  watch: {
    currentDataMode() {
      this.updateRainfallChart()
    }
  },
  methods: {
    goToStatistics() {
      this.$router.push({ name: 'Statistics' })
    },
    goToPrediction() {
      this.$router.push({ name: 'Predictive' })
    },
    goToUpstreamFlow() {
      window.open('https://moodsci.com/watherfocast/#/upstream-flow-entry', '_blank')
    },
    goToIntervalFlowEntry() {
      window.open('https://moodsci.com/watherfocast/#/interval-flow-entry', '_blank')
      // this.$router.push({ name: 'IntervalFlowEntry' })
    },
    handleLogout() {
      this.$confirm('确定要退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        localStorage.removeItem('isLoggedIn')
        localStorage.removeItem('username')
        localStorage.removeItem('userId')
        localStorage.removeItem('stationId')
        localStorage.removeItem('hyStation')
        localStorage.removeItem('rememberedUser')
        this.$message.success('已退出登录')
        this.$router.push('/login')
      }).catch(() => {})
    },
    onAdminStationChange() {
      this.warningData = null
      this.clearGridData()
      this.fetchDrainGeoJSON()
      this.fetchStationMarkers()
      this.fetchData()
      this.fetchWarning()
    },
    updateTime() {
      const now = new Date()
      const year = now.getFullYear()
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const day = String(now.getDate()).padStart(2, '0')
      const hours = String(now.getHours()).padStart(2, '0')
      const minutes = String(now.getMinutes()).padStart(2, '0')
      const seconds = String(now.getSeconds()).padStart(2, '0')
      const weekDays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
      const weekDay = weekDays[now.getDay()]
      this.currentTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds} ${weekDay}`
    },
    async fetchWarning() {
      try {
        const formData = new FormData()
        formData.append('find', this.effectiveStationId || '')
        const response = await axios.post('https://moodsci.com/lsserver/api/warn/warning', formData)
        if (response.data && response.data.code === 200) {
          this.warningData = response.data.data
        } else {
          this.warningData = null
        }
      } catch {
        this.warningData = null
      }
    },
    getYesterday() {
      const yesterday = new Date()
      yesterday.setDate(yesterday.getDate() - 1)
      const year = yesterday.getFullYear()
      const month = String(yesterday.getMonth() + 1).padStart(2, '0')
      const day = String(yesterday.getDate()).padStart(2, '0')
      return `${year}-${month}-${day} 00:00:00`
    },
    initComparisonChart() {
      this.comparisonChartInstance = echarts.init(this.$refs.comparisonChart)
      const option = {
        tooltip: { trigger: 'axis', valueFormatter: (value) => (typeof value === 'number' ? value.toFixed(2) : value) },
        grid: { top: 40, bottom: 10, left: 55, right: 15 },
        legend: {
          data: [this.comparisonData.predictedName, this.comparisonData.actualName],
          textStyle: { color: '#fff' },
          top: 5
        },
        xAxis: {
          type: 'category',
          data: [],
          axisLine: { lineStyle: { color: '#fff' } },
          axisLabel: { color: '#ccc' }
        },
        yAxis: {
          type: 'value',
          name: '流量(m³/s)',
          axisLine: { lineStyle: { color: '#fff' } },
          axisLabel: { color: '#ccc' },
          splitLine: { lineStyle: { color: '#555', type: 'dashed' } }
        },
        series: [
          {
            name: this.comparisonData.predictedName,
            type: 'line',
            data: [],
            smooth: true,
            itemStyle: { color: '#ffaa00' },
            lineStyle: { width: 2 }
          },
          {
            name: this.comparisonData.actualName,
            type: 'line',
            data: [],
            smooth: true,
            itemStyle: { color: '#67c23a' },
            lineStyle: { width: 2 }
          }
        ]
      }
      this.comparisonChartInstance.setOption(option)
    },
    initDailyChart() {
      this.dailyChartInstance = echarts.init(this.$refs.dailyChart)
      const option = {
        tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' }, valueFormatter: (value) => (typeof value === 'number' ? value.toFixed(2) : value) },
        legend: {
          data: ['逐日流量', '区间流量'],
          textStyle: { color: '#ccc' }
        },
        xAxis: {
          type: 'category',
          data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
          axisLine: { lineStyle: { color: '#fff' } },
          axisLabel: { color: '#ccc' }
        },
        yAxis: {
          type: 'value',
          name: '流量(m³/s)',
          axisLine: { lineStyle: { color: '#fff' } },
          axisLabel: { color: '#ccc' },
          splitLine: { lineStyle: { color: '#555', type: 'dashed' } }
        },
        series: [
          {
            name: '逐日流量',
            type: 'bar',
            data: [150, 180, 160, 200, 220, 190, 170],
            itemStyle: { color: { type: 'linear', x: 0, y: 0, x2: 0, y2: 1, colorStops: [{ offset: 0, color: '#00d8ff' }, { offset: 1, color: '#006e99' }] } },
            label: { show: true, position: 'top', color: '#00d8ff', fontSize: 10, formatter: (p) => p.value.toFixed(2) }
          },
          {
            name: '区间流量',
            type: 'bar',
            data: [75, 90, 80, 100, 110, 95, 85],
            itemStyle: { color: { type: 'linear', x: 0, y: 0, x2: 0, y2: 1, colorStops: [{ offset: 0, color: '#67c23a' }, { offset: 1, color: '#3a8a1f' }] } },
            label: { show: true, position: 'top', color: '#67c23a', fontSize: 10, formatter: (p) => p.value.toFixed(2) }
          },
          {
            name: '逐日趋势',
            type: 'line',
            data: [150, 180, 160, 200, 220, 190, 170],
            smooth: true,
            itemStyle: { color: '#00d8ff' },
            lineStyle: { width: 2 },
            tooltip: { show: false }
          },
          {
            name: '区间趋势',
            type: 'line',
            data: [75, 90, 80, 100, 110, 95, 85],
            smooth: true,
            itemStyle: { color: '#67c23a' },
            lineStyle: { width: 2 },
            tooltip: { show: false }
          }
        ]
      }
      this.dailyChartInstance.setOption(option)
    },
    initInspectionChart() {
      this.inspectionChartInstance = echarts.init(this.$refs.inspectionChart)
      const dates = []
      const scores = []
      const today = new Date()
      for (let i = 9; i >= 0; i--) {
        const date = new Date(today)
        date.setDate(date.getDate() - i)
        const month = date.getMonth() + 1
        const day = date.getDate()
        dates.push(`${month}/${day}`)
        scores.push(Math.floor(Math.random() * 30) + 70)
      }
      const option = {
        tooltip: { trigger: 'axis', valueFormatter: (value) => (typeof value === 'number' ? value.toFixed(2) : value) },
        xAxis: {
          type: 'category',
          data: dates,
          axisLine: { lineStyle: { color: '#fff' } },
          axisLabel: { color: '#ccc' }
        },
        yAxis: {
          type: 'value',
          name: '检验评分',
          axisLine: { lineStyle: { color: '#fff' } },
          axisLabel: { color: '#ccc' },
          splitLine: { lineStyle: { color: '#555', type: 'dashed' } }
        },
        series: [{
          name: '检验评分',
          type: 'line',
          data: scores,
          smooth: true,
          itemStyle: { color: '#00d8ff' },
          areaStyle: {
            color: {
              type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
              colorStops: [
                { offset: 0, color: 'rgba(0, 216, 255, 0.5)' },
                { offset: 1, color: 'rgba(0, 216, 255, 0.1)' }
              ]
            }
          }
        }]
      }
      this.inspectionChartInstance.setOption(option)
    },
    initRainfallChart() {
      this.rainfallChartInstance = echarts.init(this.$refs.rainfallChart)
      const option = this.getRainfallChartOption('daily')
      this.rainfallChartInstance.setOption(option)
    },
    getRainfallChartOption(mode) {
      if (mode === 'daily') {
        return {
          tooltip: { trigger: 'axis', valueFormatter: (value) => (typeof value === 'number' ? value.toFixed(2) : value) },
          xAxis: {
            type: 'category',
            data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
            axisLine: { lineStyle: { color: '#fff' } },
            axisLabel: { color: '#ccc' }
          },
          yAxis: {
            type: 'value',
            name: '雨量(mm)',
            axisLine: { lineStyle: { color: '#fff' } },
            axisLabel: { color: '#ccc' },
            splitLine: { lineStyle: { color: '#555', type: 'dashed' } }
          },
          series: [{
            name: '逐日雨量',
            type: 'bar',
            data: [25, 32, 18, 45, 38, 22, 15],
            itemStyle: { color: { type: 'linear', x: 0, y: 0, x2: 0, y2: 1, colorStops: [{ offset: 0, color: '#00d8ff' }, { offset: 1, color: '#006e99' }] } },
            label: { show: true, position: 'top', color: '#00d8ff', fontSize: 10, formatter: (p) => p.value }
          }]
        }
      } else if (mode === 'hourly') {
        return {
          tooltip: { trigger: 'axis', valueFormatter: (value) => (typeof value === 'number' ? value.toFixed(2) : value) },
          xAxis: {
            type: 'category',
            data: ['00:00', '02:00', '04:00', '06:00', '08:00', '10:00', '12:00', '14:00', '16:00', '18:00', '20:00', '22:00'],
            axisLine: { lineStyle: { color: '#fff' } },
            axisLabel: { color: '#ccc' }
          },
          yAxis: {
            type: 'value',
            name: '雨量(mm)',
            axisLine: { lineStyle: { color: '#fff' } },
            axisLabel: { color: '#ccc' },
            splitLine: { lineStyle: { color: '#555', type: 'dashed' } }
          },
          series: [{
            name: '逐时雨量',
            type: 'line',
            data: [5, 8, 12, 15, 10, 7, 3, 6, 9, 11, 8, 4],
            smooth: true,
            itemStyle: { color: '#00d8ff' },
            areaStyle: {
              color: {
                type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
                colorStops: [{ offset: 0, color: 'rgba(0, 216, 255, 0.5)' }, { offset: 1, color: 'rgba(0, 216, 255, 0.1)' }]
              }
            }
          }]
        }
      } else {
        return {
          tooltip: { trigger: 'axis', valueFormatter: (value) => (typeof value === 'number' ? value.toFixed(2) : value) },
          xAxis: {
            type: 'category',
            data: ['00:00', '02:00', '04:00', '06:00', '08:00', '10:00', '12:00', '14:00', '16:00', '18:00', '20:00', '22:00'],
            axisLine: { lineStyle: { color: '#fff' } },
            axisLabel: { color: '#ccc' }
          },
          yAxis: {
            type: 'value',
            name: '流量(m³/s)',
            axisLine: { lineStyle: { color: '#fff' } },
            axisLabel: { color: '#ccc' },
            splitLine: { lineStyle: { color: '#555', type: 'dashed' } }
          },
          series: [{
            name: '流量数据',
            type: 'line',
            data: [120, 132, 101, 134, 190, 230, 210, 180, 160, 175, 190, 150],
            smooth: true,
            itemStyle: { color: '#00d8ff' },
            areaStyle: {
              color: {
                type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
                colorStops: [{ offset: 0, color: 'rgba(0, 216, 255, 0.5)' }, { offset: 1, color: 'rgba(0, 216, 255, 0.1)' }]
              }
            }
          }]
        }
      }
    },
    updateRainfallChart() {
      if (this.currentDataMode === 'daily') {
        this.updateDayRainChart(this.forrain, this.trueRain)
      } else if (this.currentDataMode === 'hourly') {
        this.updateHourRainChart(this.currentHourRainData)
      } else {
        this.updateFlowChart(this.currentDayRealRainData, this.currentDayRainData)
      }
    },
    handleResize() {
      if (this.comparisonChartInstance) this.comparisonChartInstance.resize()
      if (this.comparisonFullscreenChartInstance) this.comparisonFullscreenChartInstance.resize()
      if (this.dailyChartInstance) this.dailyChartInstance.resize()
      if (this.dailyFullscreenChartInstance) this.dailyFullscreenChartInstance.resize()
      if (this.inspectionChartInstance) this.inspectionChartInstance.resize()
      if (this.inspectionFullscreenChartInstance) this.inspectionFullscreenChartInstance.resize()
      if (this.rainfallChartInstance) this.rainfallChartInstance.resize()
      if (this.rainfallFullscreenChartInstance) this.rainfallFullscreenChartInstance.resize()
      if (this.mapData && this.mapData.map) this.mapData.map.invalidateSize()
      if (this.mapFullscreenInstance && this.mapFullscreenInstance.map) this.mapFullscreenInstance.map.invalidateSize()
    },
    openFlowEntry() {
      this.$router.push('/flow-entry')
    },
    downloadDailyChart() {
      if (this.dailyChartInstance) {
        const link = document.createElement('a')
        link.download = '逐日流量预测.png'
        link.href = this.dailyChartInstance.getDataURL()
        link.click()
      }
    },
    toggleDailyTable() {
      if (this.showDailyTable) {
        if (!this.dailyChartInstance) {
          this.initDailyChart()
          if (this.dailyTableData && this.dailyTableData.length > 0) {
            this.updateDailyChart(this.dailyTableData)
          }
        }
      }
      this.showDailyTable = !this.showDailyTable
    },
    toggleComparisonFullscreen() {
      if (this.comparisonFullscreen) {
        if (this.comparisonFullscreenChartInstance) {
          this.comparisonFullscreenChartInstance.dispose()
          this.comparisonFullscreenChartInstance = null
        }
        this.comparisonFullscreen = false
      } else {
        this.comparisonFullscreen = true
        this.$nextTick(() => {
          this.comparisonFullscreenChartInstance = echarts.init(this.$refs.comparisonFullscreenChart)
          if (this.comparisonChartInstance) {
            const option = this.comparisonChartInstance.getOption()
            this.comparisonFullscreenChartInstance.setOption(option)
          }
          this.comparisonFullscreenChartInstance.resize()
        })
      }
    },
    toggleRainfallFullscreen() {
      if (this.rainfallFullscreen) {
        if (this.rainfallFullscreenChartInstance) {
          this.rainfallFullscreenChartInstance.dispose()
          this.rainfallFullscreenChartInstance = null
        }
        this.rainfallFullscreen = false
      } else {
        this.rainfallFullscreen = true
        this.$nextTick(() => {
          this.rainfallFullscreenChartInstance = echarts.init(this.$refs.rainfallFullscreenChart)
          if (this.rainfallChartInstance) {
            const option = this.rainfallChartInstance.getOption()
            this.rainfallFullscreenChartInstance.setOption(option)
          }
          this.rainfallFullscreenChartInstance.resize()
        })
      }
    },
    toggleInspectionFullscreen() {
      if (this.inspectionFullscreen) {
        if (this.inspectionFullscreenChartInstance) {
          this.inspectionFullscreenChartInstance.dispose()
          this.inspectionFullscreenChartInstance = null
        }
        this.inspectionFullscreen = false
      } else {
        this.inspectionFullscreen = true
        this.$nextTick(() => {
          this.inspectionFullscreenChartInstance = echarts.init(this.$refs.inspectionFullscreenChart)
          if (this.inspectionChartInstance) {
            const option = this.inspectionChartInstance.getOption()
            this.inspectionFullscreenChartInstance.setOption(option)
          }
          this.inspectionFullscreenChartInstance.resize()
        })
      }
    },
    toggleMapFullscreen() {
      if (this.mapFullscreen) {
        if (this.mapFullscreenInstance && this.mapFullscreenInstance.map) {
          this.mapFullscreenInstance.map.remove()
          this.mapFullscreenInstance = null
        }
        this.mapFullscreen = false
        this.$nextTick(() => {
          if (this.mapData && this.mapData.map) {
            this.mapData.map.invalidateSize()
          }
        })
      } else {
        this.mapFullscreen = true
        this.$nextTick(() => {
          const fullMap = new MapCreate()
          this.mapFullscreenInstance = fullMap
          const mapObj = fullMap.init(this.$refs.mapFullscreenContainer)
          const stationId = localStorage.getItem('stationId') || ''

          const loadDrain = () => {
            const urls = (stationId === '513201' || stationId === '10000')
              ? [
                  'https://www.moodsci.com/imagesbackend/json/513201.json',
                  'https://www.moodsci.com/imagesbackend/json/513202.json',
                  'https://www.moodsci.com/imagesbackend/json/513203.json'
                ]
              : [`https://www.moodsci.com/imagesbackend/json/${stationId}.json`]
            return Promise.all(urls.map(url => axios({ url, method: 'get' })))
              .then((responses) => {
                const allFeatures = []
                responses.forEach(res => {
                  if (res.data && res.data.features) {
                    allFeatures.push(...res.data.features)
                  }
                })
                L.geoJSON(allFeatures, { color: 'red', fillOpacity: 0, className: 'dashLine' }).addTo(mapObj)
                L.geoJSON(rodjosn.features, { color: 'blue', fillOpacity: 0, className: 'dashLine' }).addTo(mapObj)
              })
          }

          const loadGrid = () => {
            return axios({
              url: 'https://moodsci.com/lsserver/api/hydro/areaRainfaill',
              method: 'get',
              params: { find: this.effectiveStationId }
            }).then((res) => {
              if (res.data.code != 200 && !res.data.success) return
              const gridData = res.data.data
              if (!gridData || !gridData.datas) return
              const gridList = gridData.datas.split(',').map(Number)

              const tileLayer = L.tilePixelLayer({
                newData: gridList,
                data: gridData,
                gradient: this.getAdjustedRainGradient(),
                clickEvt: (e, gridValue) => {
                  L.popup({
                    autoPanPaddingBottomRight: L.point(600, 0),
                    closeButton: true
                  })
                    .setLatLng([e.latlng.lat, e.latlng.lng])
                    .setContent(`
                      <div style="text-align: center;">
                        <div style="font-weight: bold; margin-bottom: 5px;">格点信息</div>
                        <div>经度: ${e.latlng.lng.toFixed(4)}</div>
                        <div>纬度: ${e.latlng.lat.toFixed(4)}</div>
                        <div style="color: #409eff; font-weight: bold; margin-top: 5px;">
                          雨量值: ${gridValue} mm
                        </div>
                      </div>
                    `)
                    .openOn(mapObj)
                }
              })
              mapObj.addLayer(tileLayer)

              const cols = gridData.cols || Math.round(Math.sqrt(gridList.length))
              const rows = gridData.rows || Math.round(gridList.length / cols)
              const left = gridData.left
              const right = gridData.right
              const top = gridData.top
              const bottom = gridData.bottom
              const lonStep = (right - left) / cols
              const latStep = (top - bottom) / rows

              const linesLayer = L.layerGroup()
              for (let i = 0; i <= cols; i++) {
                const lon = left + i * lonStep
                linesLayer.addLayer(L.polyline([[bottom, lon], [top, lon]], { color: 'rgba(255, 255, 255, 0.5)', weight: 1 }))
              }
              for (let j = 0; j <= rows; j++) {
                const lat = bottom + j * latStep
                linesLayer.addLayer(L.polyline([[lat, left], [lat, right]], { color: 'rgba(255, 255, 255, 0.5)', weight: 1 }))
              }
              linesLayer.addTo(mapObj)

              const valuesLayer = L.layerGroup()
              for (let j = 0; j < rows; j++) {
                for (let i = 0; i < cols; i++) {
                  const index = j * cols + i
                  if (index < gridList.length) {
                    const value = parseFloat(gridList[index])
                    if (!isNaN(value)) {
                      const centerLon = left + (i + 0.5) * lonStep
                      const centerLat = bottom + (j + 0.5) * latStep
                      const myIcon = L.divIcon({
                        className: 'grid-value-label',
                        html: `<div style="font-size: 10px; color: #fff; text-shadow: 0 0 4px #000; white-space: nowrap;">${value.toFixed(1)}</div>`,
                        iconSize: [60, 14],
                        iconAnchor: [30, 7]
                      })
                      L.marker([centerLat, centerLon], { icon: myIcon, interactive: false }).addTo(valuesLayer)
                    }
                  }
                }
              }
              valuesLayer.addTo(mapObj)

              const legendControl = L.control({ position: 'bottomright' })
              legendControl.onAdd = () => {
                const div = L.DomUtil.create('div', 'grid-legend')
                div.style.pointerEvents = 'auto'
                div.innerHTML = `
                  <div style="background: rgba(0,0,0,0.75); padding: 10px 12px; border-radius: 4px; border: 1px solid rgba(0,216,255,0.3); box-shadow: 0 2px 12px rgba(0,0,0,0.5); font-size: 12px; color: #eee; min-width: 100px;">
                    <div style="font-weight: bold; margin-bottom: 8px; color: #00d8ff; font-size: 13px;">雨量图例 (mm)</div>
                    <div style="display: flex; align-items: center; margin-bottom: 5px;"><span style="display: inline-block; width: 24px; height: 14px; background: #FFFFFF; margin-right: 8px; border-radius: 2px; border: 1px solid #555;"></span><span style="color: #ddd;">无降水</span></div>
                    <div style="display: flex; align-items: center; margin-bottom: 5px;"><span style="display: inline-block; width: 24px; height: 14px; background: #91EE91; margin-right: 8px; border-radius: 2px;"></span><span style="color: #ddd;">0.1~10 小雨</span></div>
                    <div style="display: flex; align-items: center; margin-bottom: 5px;"><span style="display: inline-block; width: 24px; height: 14px; background: #22B122; margin-right: 8px; border-radius: 2px;"></span><span style="color: #ddd;">10~25 中雨</span></div>
                    <div style="display: flex; align-items: center; margin-bottom: 5px;"><span style="display: inline-block; width: 24px; height: 14px; background: #46AAFF; margin-right: 8px; border-radius: 2px;"></span><span style="color: #ddd;">25~50 大雨</span></div>
                    <div style="display: flex; align-items: center; margin-bottom: 5px;"><span style="display: inline-block; width: 24px; height: 14px; background: #0000DC; margin-right: 8px; border-radius: 2px;"></span><span style="color: #ddd;">50~100 暴雨</span></div>
                    <div style="display: flex; align-items: center; margin-bottom: 5px;"><span style="display: inline-block; width: 24px; height: 14px; background: #E600E6; margin-right: 8px; border-radius: 2px;"></span><span style="color: #ddd;">100~250 大暴雨</span></div>
                    <div style="display: flex; align-items: center;"><span style="display: inline-block; width: 24px; height: 14px; background: #78003C; margin-right: 8px; border-radius: 2px;"></span><span style="color: #ddd;">≥250 特大暴雨</span></div>
                  </div>
                `
                return div
              }
              legendControl.addTo(mapObj)

              mapObj.fitBounds([[bottom, left], [top, right]])
            }).catch((error) => {
              console.error('全屏地图加载格点数据失败:', error)
            })
          }

          Promise.all([loadDrain(), loadGrid()])
        })
      }
    },
    toggleDailyFullscreen() {
      if (this.dailyFullscreen) {
        if (this.dailyFullscreenChartInstance) {
          this.dailyFullscreenChartInstance.dispose()
          this.dailyFullscreenChartInstance = null
        }
        this.dailyFullscreen = false
      } else {
        this.dailyFullscreen = true
        this.$nextTick(() => {
          this.dailyFullscreenChartInstance = echarts.init(this.$refs.dailyFullscreenChart)
          if (this.dailyChartInstance) {
            const option = this.dailyChartInstance.getOption()
            this.dailyFullscreenChartInstance.setOption(option)
          }
          this.dailyFullscreenChartInstance.resize()
        })
      }
    },
    async fetchData() {
      this.pageLoading = true
      try {
        const queryStationId = this.effectiveStationId || ''
        const response = await axios.post(`https://moodsci.com/lsserver/api/hydro/InspectionDayHourResults?date=${this.selectedDate}&type=${this.selectedModel}&find=${queryStationId}`)
        if (response.data.success) {
          const data = response.data.data
          this.currentDayRainData = data.dayRain || []
          this.currentHourRainData = data.hourRain || []
          this.currentDayRealRainData = data.dayRealRain || []
          this.trueRain = data.dayRain || []
          this.forrain = data.dayPredictRained || []
          this.updateInspectionChart(data.InspectionResults)
          this.updateDailyChart(data.dayPredictTraffic)
          this.updateComparisonData(data)
          this.updateComparisonChart(this.comparisonData)
          this.updateRainfallChart()
          this.getGridData()
        }
      } catch (error) {
        console.error('获取数据失败:', error)
      } finally {
        this.pageLoading = false
      }
    },
    updateComparisonData(data) {
      const dates = []
      const actual = []
      const predicted = []
      const actualFlow = []

      if (data.preRateTraffics && data.preRateTraffics.length > 0) {
        data.preRateTraffics.forEach(item => {
          dates.push(item.date.substring(5, 10))
          actual.push(item.PredictRealRained || 0)
        })
      }

      if (data.preRateTraffics && data.preRateTraffics.length > 0) {
        data.preRateTraffics.forEach(item => {
          predicted.push(item.fcest || 0)
        })
      }

      if (data.preRateTrafficsReal != null) {
        dates.forEach(() => {
          actualFlow.push(Number(data.preRateTrafficsReal) || 0)
        })
      }

      const dayNum = this.selectedDate.substring(8, 10) + '号'
      const predictedName = `过去10天对${dayNum}预测流量`
      const actualName = `${dayNum}实际流量`

      this.comparisonData = {
        dates: dates,
        actual: actual,
        predicted: predicted,
        actualFlow: actualFlow,
        predictedName: predictedName,
        actualName: actualName
      }
    },
    updateInspectionChart(results) {
      const dates = results.map(item => item.date_time.substring(5, 10))
      const avgPres = results.map(item => item.error_value.toFixed(2))
      const option = {
        tooltip: { trigger: 'axis', valueFormatter: (value) => (typeof value === 'number' ? value.toFixed(2) : value) },
        xAxis: {
          type: 'category',
          data: dates,
          axisLine: { lineStyle: { color: '#fff' } },
          axisLabel: { color: '#ccc' }
        },
        yAxis: {
          type: 'value',
          name: '检验评分',
          axisLine: { lineStyle: { color: '#fff' } },
          axisLabel: { color: '#ccc' },
          splitLine: { lineStyle: { color: '#555', type: 'dashed' } }
        },
        series: [{
          name: '检验评分',
          type: 'line',
          data: avgPres,
          smooth: true,
          itemStyle: { color: '#00d8ff' },
          label: {
            show: true,
            color: '#00d8ff',
            fontSize: 10,
            position: 'top',
            formatter: (p) => p.value
          },
          areaStyle: {
            color: {
              type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
              colorStops: [
                { offset: 0, color: 'rgba(0, 216, 255, 0.5)' },
                { offset: 1, color: 'rgba(0, 216, 255, 0.1)' }
              ]
            }
          }
        }]
      }
      this.inspectionChartInstance.setOption(option)
    },
    updateDailyChart(dayData) {
      let timeList = dayData.map(item => item.daytime.substring(5, 10))
      let dailyFlowData = dayData.map(item => item.dayPredictPredictTraffic || 0)
      let intervalFlowData = dayData.map(item => Number(((item.dayPredictPredictTraffic || 0) / 2).toFixed(2)))
      this.dailyTableData = dayData

      const option = {
        tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' }, valueFormatter: (value) => (typeof value === 'number' ? value.toFixed(2) : value) },
        legend: {
          data: ['逐日流量', '区间流量'],
          textStyle: { color: '#ccc' }
        },
        xAxis: {
          type: 'category',
          data: timeList,
          axisLine: { lineStyle: { color: '#fff' } },
          axisLabel: { color: '#ccc' }
        },
        yAxis: {
          type: 'value',
          name: '流量(m³/s)',
          axisLine: { lineStyle: { color: '#fff' } },
          axisLabel: { color: '#ccc' },
          splitLine: { lineStyle: { color: '#555', type: 'dashed' } }
        },
        series: [
          {
            name: '逐日流量',
            type: 'bar',
            data: dailyFlowData,
            itemStyle: { color: { type: 'linear', x: 0, y: 0, x2: 0, y2: 1, colorStops: [{ offset: 0, color: '#00d8ff' }, { offset: 1, color: '#006e99' }] } },
            label: { show: true, color: '#fff', fontSize: 11 }
          },
          {
            name: '区间流量',
            type: 'bar',
            data: intervalFlowData,
            itemStyle: { color: { type: 'linear', x: 0, y: 0, x2: 0, y2: 1, colorStops: [{ offset: 0, color: '#67c23a' }, { offset: 1, color: '#3a8a1f' }] } },
            label: { show: true, color: '#fff', fontSize: 11 }
          },
          {
            name: '逐日趋势',
            type: 'line',
            data: dailyFlowData,
            smooth: true,
            itemStyle: { color: '#00d8ff' },
            lineStyle: { width: 2 },
            tooltip: { show: false }
          },
          {
            name: '区间趋势',
            type: 'line',
            data: intervalFlowData,
            smooth: true,
            itemStyle: { color: '#67c23a' },
            lineStyle: { width: 2 },
            tooltip: { show: false }
          }
        ]
      }
      this.dailyChartInstance.setOption(option)
    },
    updateComparisonChart(comparisonData) {
      if (!comparisonData || !comparisonData.dates || comparisonData.dates.length === 0) return
      const option = {
        tooltip: { trigger: 'axis', valueFormatter: (value) => (typeof value === 'number' ? value.toFixed(2) : value) },
        grid: { top: 100, bottom: 10, left: 55, right: 15 },
        legend: {
          data: [comparisonData.predictedName, comparisonData.actualName],
          textStyle: { color: '#fff' },
          top: 30
        },
        xAxis: {
          type: 'category',
          data: comparisonData.dates,
          axisLine: { lineStyle: { color: '#fff' } },
          axisLabel: { color: '#ccc' }
        },
        yAxis: {
          type: 'value',
          name: '流量(m³/s)',
          axisLine: { lineStyle: { color: '#fff' } },
          axisLabel: { color: '#ccc' },
          splitLine: { lineStyle: { color: '#555', type: 'dashed' } }
        },
        series: [
          {
            name: comparisonData.predictedName,
            type: 'line',
            data: comparisonData.predicted,
            smooth: true,
            itemStyle: { color: '#ffaa00' },
            lineStyle: { width: 2 },
            label: {
              show: true,
              color: '#ffaa00',
              fontSize: 10,
              position: 'top',
              formatter: (p) => p.value.toFixed(0)
            }
          },
          {
            name: comparisonData.actualName,
            type: 'line',
            data: comparisonData.actualFlow,
            smooth: true,
            itemStyle: { color: '#67c23a' },
            lineStyle: { width: 2 },
            label: {
              show: true,
              color: '#67c23a',
              fontSize: 10,
              position: 'bottom',
              formatter: (p) => p.value.toFixed(0)
            }
          }
        ]
      }
      this.comparisonChartInstance.setOption(option, { notMerge: true, lazyUpdate: true })
    },
    updateDayRainChart(dayRainData, dayRealRainData) {
      let actualRainData = dayRealRainData.map(item => item.dayPredictRained || 0)
      let predictedRainData = dayRainData.map(item => item.dayPredictRained || 0)
      let combinedData = [...actualRainData, ...predictedRainData]
      let timeList = []

      dayRealRainData.forEach(item => {
        timeList.push(item.datetime.substring(5, 10))
      })
      dayRainData.forEach(item => {
        timeList.push(item.datetime.substring(5, 10))
      })

      let colorList = []
      for (let i = 0; i < actualRainData.length; i++) colorList.push('#00d8ff')
      for (let i = 0; i < predictedRainData.length; i++) colorList.push('#ffaa00')

      const option = {
        tooltip: { trigger: 'axis', valueFormatter: (value) => (typeof value === 'number' ? value.toFixed(2) : value) },
        legend: {
          data: ['实际雨量', '预测雨量'],
          textStyle: { color: '#fff' },
          top: 10
        },
        xAxis: {
          type: 'category',
          data: timeList,
          axisLine: { lineStyle: { color: '#fff' } },
          axisLabel: { color: '#ccc' }
        },
        yAxis: {
          type: 'value',
          name: '雨量(mm)',
          axisLine: { lineStyle: { color: '#fff' } },
          axisLabel: { color: '#ccc' },
          splitLine: { lineStyle: { color: '#555', type: 'dashed' } }
        },
        series: [{
          name: '雨量',
          type: 'line',
          data: combinedData,
          smooth: true,
          itemStyle: {
            color: function (params) {
              return colorList[params.dataIndex] || '#ffaa00'
            }
          },
          lineStyle: { width: 2 },
          label: {
            show: true,
            position: 'top',
            fontSize: 10,
            color: function (params) {
              return colorList[params.dataIndex] || '#ffaa00'
            },
            formatter: (p) => p.value.toFixed(2)
          }
        }]
      }
      this.rainfallChartInstance.setOption(option, { notMerge: true, lazyUpdate: true })
    },
    updateHourRainChart(hourRainData) {
      let timeList = hourRainData.map(item => item.datetime.substring(5, 10))
      let rainData = hourRainData.map(item => item.PredictRained || 0)
      const option = {
        tooltip: { trigger: 'axis' },
        xAxis: {
          type: 'category',
          data: timeList,
          axisLine: { lineStyle: { color: '#fff' } },
          axisLabel: { color: '#ccc' }
        },
        yAxis: {
          type: 'value',
          name: '雨量(mm)',
          axisLine: { lineStyle: { color: '#fff' } },
          axisLabel: { color: '#ccc' },
          splitLine: { lineStyle: { color: '#555', type: 'dashed' } }
        },
        series: [{
          name: '面雨量',
          type: 'line',
          data: rainData,
          smooth: true,
          itemStyle: { color: '#00d8ff' },
          label: { show: true, position: 'top', color: '#00d8ff', fontSize: 10, formatter: (p) => p.value.toFixed(2) },
          areaStyle: {
            color: {
              type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
              colorStops: [{ offset: 0, color: 'rgba(0, 216, 255, 0.5)' }, { offset: 1, color: 'rgba(0, 216, 255, 0.1)' }]
            }
          }
        }]
      }
      this.rainfallChartInstance.setOption(option, { notMerge: true, lazyUpdate: true })
    },
    updateFlowChart(dayRealRainData, dayRainData) {
      let timeList = dayRealRainData.map(item => item.datetime.substring(5, 10))
      let realFlowData = dayRealRainData.map(item => item.PredictRealRained || 0)
      let dayRainDataList = dayRainData.map(item => item.dayPredictRained || 0)
      const option = {
        tooltip: { trigger: 'axis', valueFormatter: (value) => (typeof value === 'number' ? value.toFixed(2) : value) },
        legend: {
          data: ['实时逐日雨量', '实时流量'],
          textStyle: { color: '#fff' },
          top: 10
        },
        xAxis: {
          type: 'category',
          data: timeList,
          axisLine: { lineStyle: { color: '#fff' } },
          axisLabel: { color: '#ccc' }
        },
        yAxis: {
          type: 'value',
          name: '流量(m³/s)',
          axisLine: { lineStyle: { color: '#fff' } },
          axisLabel: { color: '#ccc' },
          splitLine: { lineStyle: { color: '#555', type: 'dashed' } }
        },
        series: [
          {
            name: '实时逐日雨量',
            type: 'line',
            data: dayRainDataList,
            smooth: true,
            itemStyle: { color: '#00d8ff' },
            lineStyle: { width: 2 },
            label: { show: true, position: 'top', color: '#00d8ff', fontSize: 10, formatter: (p) => p.value.toFixed(2) }
          },
          {
            name: '实时流量',
            type: 'line',
            data: realFlowData,
            smooth: true,
            itemStyle: { color: '#ffaa00' },
            lineStyle: { width: 2 },
            label: { show: true, position: 'top', color: '#ffaa00', fontSize: 10, formatter: (p) => p.value.toFixed(2) }
          }
        ]
      }
      this.rainfallChartInstance.setOption(option, { notMerge: true, lazyUpdate: true })
    },

    initMap() {
      this.mapData = new MapCreate()
      this.mapData.init('homeMap')
      this.fetchDrainGeoJSON()
      L.geoJSON(rodjosn.features, {
        color: 'blue',
        fillOpacity: 0,
        className: 'dashLine'
      }).addTo(this.mapData.map)
      this.fetchStationMarkers()
    },

    fetchDrainGeoJSON() {
      const stationId = localStorage.getItem('stationId') || ''
      const loadAllThree = stationId === '513201' || stationId === '10000'
      const urls = loadAllThree
        ? [
            'https://www.moodsci.com/imagesbackend/json/513201.json',
            'https://www.moodsci.com/imagesbackend/json/513202.json',
            'https://www.moodsci.com/imagesbackend/json/513203.json'
          ]
        : [`https://www.moodsci.com/imagesbackend/json/${stationId}.json`]

      Promise.all(urls.map(url => axios({ url, method: 'get' })))
        .then((responses) => {
          if (!this.mapData || !this.mapData.map) return
          if (this.drainLayer) {
            this.mapData.map.removeLayer(this.drainLayer)
            this.drainLayer = null
          }
          const allFeatures = []
          responses.forEach(res => {
            if (res.data && res.data.features) {
              allFeatures.push(...res.data.features)
            }
          })
          this.drainLayer = L.geoJSON(allFeatures, {
            color: 'red',
            fillOpacity: 0,
            className: 'dashLine'
          }).addTo(this.mapData.map)
        }).catch((error) => {
          console.error('获取流域面数据失败:', error)
        })
    },

    fetchStationMarkers() {
      axios({
        url: 'https://moodsci.com/lsserver/api/hydro/getHydroSearch',
        method: 'get',
        params: {
          find: this.effectiveStationId || ''
        }
      }).then((res) => {
        if (res.data.code != 200) {
          console.warn('获取水电站标记数据失败:', res.data.message)
          return
        }
        const data = res.data.data
        if (data && data.length > 0) {
          this.addStationMarkers(data)
        }
      }).catch((error) => {
        console.error('获取水电站标记数据失败:', error)
      })
    },

    addStationMarkers(stationList) {
      if (!this.mapData || !this.mapData.map) return
      if (this.stationMarkersLayer) {
        this.mapData.map.removeLayer(this.stationMarkersLayer)
        this.stationMarkersLayer = null
      }

      this.stationMarkersLayer = L.layerGroup()

      stationList.forEach((station) => {
        const lon = parseFloat(station.lon)
        const lat = parseFloat(station.lat)
        if (isNaN(lon) || isNaN(lat)) return

        const myIcon = L.icon({
          iconUrl: stationIcon,
          iconSize: [32, 32],
          iconAnchor: [16, 32],
          popupAnchor: [0, -32]
        })

        const marker = L.marker([lat, lon], { icon: myIcon })
        marker.bindPopup(`
          <div style="min-width: 220px; text-align: center;">
            <div style="font-weight: bold; font-size: 14px; margin-bottom: 8px; color: #333;">
              ${station.station_name}
            </div>
            <img src="${station.img}" style="width: 200px; height: 130px; object-fit: cover; border-radius: 4px; margin-bottom: 8px;" />
            <div style="font-size: 12px; color: #666; line-height: 1.5;">
              ${station.content}
            </div>
          </div>
        `)
        this.stationMarkersLayer.addLayer(marker)
      })

      this.stationMarkersLayer.addTo(this.mapData.map)
    },

    getGridData() {
      if (!this.mapData || !this.mapData.map) return
      if (this.gridDataLayer) {
        this.mapData.map.removeLayer(this.gridDataLayer)
        this.gridDataLayer = null
      }

      axios({
        url: 'https://moodsci.com/lsserver/api/hydro/areaRainfaill',
        method: 'get',
        params: {
          find: this.effectiveStationId || ''
        }
      }).then((res) => {
        console.log(res);
        
        if (res.data.status != 200 && !res.data.success) {
          this.$message.warning(res.data.message || '获取格点数据失败')
          return
        }

        const gridData = res.data.data

        if (!gridData || !gridData.datas) {
          this.$message.warning('格点数据格式不正确')
          return
        }

        let gridList = gridData.datas.split(',').map(Number)

        this.gridDataCache = gridData
        this.gridListCache = gridList

        this.gridDataLayer = L.tilePixelLayer({
          newData: gridList,
          data: gridData,
          gradient: this.getAdjustedRainGradient(),
          clickEvt: (e, gridValue) => {
            L.popup({
              autoPanPaddingBottomRight: L.point(600, 0),
              closeButton: true
            })
              .setLatLng([e.latlng.lat, e.latlng.lng])
              .setContent(`
                <div style="text-align: center;">
                  <div style="font-weight: bold; margin-bottom: 5px;">格点信息</div>
                  <div>经度: ${e.latlng.lng.toFixed(4)}</div>
                  <div>纬度: ${e.latlng.lat.toFixed(4)}</div>
                  <div style="color: #409eff; font-weight: bold; margin-top: 5px;">
                    雨量值: ${gridValue} mm
                  </div>
                </div>
              `)
              .openOn(this.mapData.map)
          }
        })

        this.mapData.map.addLayer(this.gridDataLayer)
        this.addGridLinesAndValues(gridData, gridList)
        this.addGridLegend()

        this.mapData.map.fitBounds([
          [gridData.bottom, gridData.left],
          [gridData.top, gridData.right]
        ])

        this.$message.success('格点数据加载成功')
      }).catch(() => {
        console.error('获取格点数据失败')
      })
    },

    addGridLegend() {
      if (this.gridLegend) {
        this.mapData.map.removeControl(this.gridLegend)
      }

      this.gridLegend = L.control({ position: 'bottomright' })

      this.gridLegend.onAdd = () => {
        let div = L.DomUtil.create('div', 'grid-legend')
        div.style.pointerEvents = 'auto'
        div.innerHTML = `
          <div style="
            background: rgba(0, 0, 0, 0.75);
            padding: 10px 12px;
            border-radius: 4px;
            border: 1px solid rgba(0, 216, 255, 0.3);
            box-shadow: 0 2px 12px rgba(0,0,0,0.5);
            font-size: 12px;
            color: #eee;
            min-width: 100px;
          ">
            <div style="font-weight: bold; margin-bottom: 8px; color: #00d8ff; font-size: 13px;">雨量图例 (mm)</div>
            <div style="display: flex; align-items: center; margin-bottom: 5px;">
              <span style="display: inline-block; width: 24px; height: 14px; background: #FFFFFF; margin-right: 8px; border-radius: 2px; border: 1px solid #555;"></span>
              <span style="color: #ddd;">无降水</span>
            </div>
            <div style="display: flex; align-items: center; margin-bottom: 5px;">
              <span style="display: inline-block; width: 24px; height: 14px; background: #91EE91; margin-right: 8px; border-radius: 2px;"></span>
              <span style="color: #ddd;">0.1~10 小雨</span>
            </div>
            <div style="display: flex; align-items: center; margin-bottom: 5px;">
              <span style="display: inline-block; width: 24px; height: 14px; background: #22B122; margin-right: 8px; border-radius: 2px;"></span>
              <span style="color: #ddd;">10~25 中雨</span>
            </div>
            <div style="display: flex; align-items: center; margin-bottom: 5px;">
              <span style="display: inline-block; width: 24px; height: 14px; background: #46AAFF; margin-right: 8px; border-radius: 2px;"></span>
              <span style="color: #ddd;">25~50 大雨</span>
            </div>
            <div style="display: flex; align-items: center; margin-bottom: 5px;">
              <span style="display: inline-block; width: 24px; height: 14px; background: #0000DC; margin-right: 8px; border-radius: 2px;"></span>
              <span style="color: #ddd;">50~100 暴雨</span>
            </div>
            <div style="display: flex; align-items: center; margin-bottom: 5px;">
              <span style="display: inline-block; width: 24px; height: 14px; background: #E600E6; margin-right: 8px; border-radius: 2px;"></span>
              <span style="color: #ddd;">100~250 大暴雨</span>
            </div>
            <div style="display: flex; align-items: center;">
              <span style="display: inline-block; width: 24px; height: 14px; background: #78003C; margin-right: 8px; border-radius: 2px;"></span>
              <span style="color: #ddd;">≥250 特大暴雨</span>
            </div>
          </div>
        `
        return div
      }

      this.gridLegend.addTo(this.mapData.map)
    },

    addGridLinesAndValues(gridData, gridList) {
      if (this.gridLinesLayer) {
        this.mapData.map.removeLayer(this.gridLinesLayer)
        this.gridLinesLayer = null
      }
      if (this.gridValuesLayer) {
        this.mapData.map.removeLayer(this.gridValuesLayer)
        this.gridValuesLayer = null
      }

      const cols = gridData.cols || Math.round(Math.sqrt(gridList.length))
      const rows = gridData.rows || Math.round(gridList.length / cols)

      const left = gridData.left
      const right = gridData.right
      const top = gridData.top
      const bottom = gridData.bottom

      const lonStep = (right - left) / cols
      const latStep = (top - bottom) / rows

      this.gridLinesLayer = L.layerGroup()

      for (let i = 0; i <= cols; i++) {
        const lon = left + i * lonStep
        this.gridLinesLayer.addLayer(
          L.polyline([[bottom, lon], [top, lon]], {
            color: 'rgba(255, 255, 255, 0.5)',
            weight: 1
          })
        )
      }

      for (let j = 0; j <= rows; j++) {
        const lat = bottom + j * latStep
        this.gridLinesLayer.addLayer(
          L.polyline([[lat, left], [lat, right]], {
            color: 'rgba(255, 255, 255, 0.5)',
            weight: 1
          })
        )
      }

      this.gridLinesLayer.addTo(this.mapData.map)

      this.gridValuesLayer = L.layerGroup()

      for (let j = 0; j < rows; j++) {
        for (let i = 0; i < cols; i++) {
          const index = j * cols + i
          if (index < gridList.length) {
            const value = parseFloat(gridList[index])
            if (!isNaN(value)) {
              const lon = left + (i + 0.5) * lonStep
              const lat = top - (j + 0.5) * latStep

              const icon = L.divIcon({
                className: 'grid-value-label',
                html: `<div style="
                  color: #fff;
                  font-size: 10px;
                  font-weight: bold;
                  text-shadow: 1px 1px 2px rgba(0,0,0,0.8);
                  white-space: nowrap;
                ">${value.toFixed(2)}</div>`,
                iconSize: [30, 12],
                iconAnchor: [15, 6]
              })

              this.gridValuesLayer.addLayer(L.marker([lat, lon], { icon: icon }))
            }
          }
        }
      }

      this.gridValuesLayer.addTo(this.mapData.map)
    },

    getAdjustedRainGradient() {
      const opacity = this.gridOpacity / 255
      return legendColor['rain'].map(([threshold, color]) => {
        return [threshold, [color[0], color[1], color[2], color[3] * opacity]]
      })
    },

    updateGridOpacity(e) {
      this.gridOpacity = Number(e.target.value)
      if (!this.mapData || !this.mapData.map) return
      if (!this.gridDataCache || !this.gridListCache) return
      if (this.gridDataLayer) {
        this.mapData.map.removeLayer(this.gridDataLayer)
        this.gridDataLayer = null
      }
      this.gridDataLayer = L.tilePixelLayer({
        newData: this.gridListCache,
        data: this.gridDataCache,
        gradient: this.getAdjustedRainGradient(),
        clickEvt: (e, gridValue) => {
          L.popup({
            autoPanPaddingBottomRight: L.point(600, 0),
            closeButton: true
          })
            .setLatLng([e.latlng.lat, e.latlng.lng])
            .setContent(`
              <div style="text-align: center;">
                <div style="font-weight: bold; margin-bottom: 5px;">格点信息</div>
                <div>经度: ${e.latlng.lng.toFixed(4)}</div>
                <div>纬度: ${e.latlng.lat.toFixed(4)}</div>
                <div style="color: #409eff; font-weight: bold; margin-top: 5px;">
                  雨量值: ${gridValue} mm
                </div>
              </div>
            `)
            .openOn(this.mapData.map)
        }
      })
      this.mapData.map.addLayer(this.gridDataLayer)
    },

    clearGridData() {
      if (this.gridDataLayer && this.mapData && this.mapData.map) {
        this.mapData.map.removeLayer(this.gridDataLayer)
        this.gridDataLayer = null
      }
      if (this.gridLinesLayer && this.mapData && this.mapData.map) {
        this.mapData.map.removeLayer(this.gridLinesLayer)
        this.gridLinesLayer = null
      }
      if (this.gridValuesLayer && this.mapData && this.mapData.map) {
        this.mapData.map.removeLayer(this.gridValuesLayer)
        this.gridValuesLayer = null
      }
      if (this.gridLegend && this.mapData && this.mapData.map) {
        this.mapData.map.removeControl(this.gridLegend)
        this.gridLegend = null
      }
      if (this.stationMarkersLayer && this.mapData && this.mapData.map) {
        this.mapData.map.removeLayer(this.stationMarkersLayer)
        this.stationMarkersLayer = null
      }
      if (this.drainLayer && this.mapData && this.mapData.map) {
        this.mapData.map.removeLayer(this.drainLayer)
        this.drainLayer = null
      }
    },

  }
}
</script>
<style scoped>
.homeViewBody {
  height: 100vh;
  background-image: url('../assets/interact.png');
  background-size: 100% 100%;
  width: 100vw;
}

.homeViewHeader {
  height: 10vh;
  color: white;
  width: 100vw;
  line-height: 8vh;
  font-size: 35px;
  font-weight: 700;
  text-align: center;
  position: relative;
}

.timeBox {
  height: 5vh;
  width: 30%;
  position: absolute;
  left: 0;
  top: 3vh;
  font-size: 18px;
  text-align: left;
  font-weight: 600;
  padding-left: 15px;
  line-height: 5vh;
  color: white;
}

.locBox {
  height: 5vh;
  width: 30%;
  position: absolute;
  right: 0;
  top: 3vh;
  font-size: 18px;
  text-align: right;
  font-weight: 600;
  padding-right: 15px;
  line-height: 5vh;
  color: #05D4EC;
}

.homeMainBox {
  height: 90vh;
  width: 100vw;
  position: relative;
  padding: 10px;
  box-sizing: border-box;
}

.mainLayout {
  display: flex;
  height: 100%;
  gap: 10px;
}

.leftColumn {
  width: 26%;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.centerColumn {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.rightColumn {
  width: 26%;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.leftColumn .card,
.rightColumn .card {
  flex: 1;
}

.centerColumn .map-card {
  flex: 2;
}

.centerColumn .card:not(.map-card) {
  flex: 1;
}

.card {
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 18px;
  font-weight: 600;
  position: relative;
}

.card > div {
  width: 100%;
  height: 100%;
}

.chart-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 10px;
  box-sizing: border-box;
}

.chart-title {
  color: #009ECA;
  font-size: 16px;
  font-weight: 600;
  position: absolute;
  left: 20px;
  top: 10px;
  text-align: center;
}

.chart-content {
  flex: 1;
  width: 100%;
  height: 100%;
  min-height: 200px;
}

.radio-group {
  display: flex;
  gap: 0;
  margin-bottom: 10px;
}

.radio-label {
  color: #a8d8ea;
  font-size: 13px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 6px 18px;
  border: 1px solid rgba(0, 216, 255, 0.3);
  border-radius: 4px;
  transition: all 0.3s;
  background: rgba(0, 216, 255, 0.05);
}

.radio-label:first-child {
  border-radius: 4px 0 0 4px;
  border-right: none;
}

.radio-label:last-child {
  border-radius: 0 4px 4px 0;
}

.radio-label:hover {
  border-color: #00d8ff;
  color: #00d8ff;
}

.radio-label input[type="radio"] {
  display: none;
}

.radio-label:has(input:checked) {
  background: rgba(0, 216, 255, 0.2);
  border-color: #00d8ff;
  color: #00d8ff;
}

.operation-content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 18px;
  padding: 10px 5px;
}

.operation-item {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
  gap: 12px;
}

.operation-item2 {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 4px;
}

.operation-item3 {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 2px;
}

.operation-item .label {
  color: #a8d8ea;
  font-size: 13px;
  font-weight: 500;
  min-width: 60px;
  text-align: right;
  letter-spacing: 0.5px;
}

.operation-item .station-name {
  color: #00d8ff;
  font-size: 14px;
  font-weight: 600;
  width: 200px;
  text-align: left;
  padding: 8px 16px;
  background: rgba(0, 216, 255, 0.08);
  border: 1px solid rgba(0, 216, 255, 0.2);
  border-radius: 4px;
}

.operation-item .radio-group {
  margin-bottom: 0;
}

.confirm-btn {
  background: linear-gradient(135deg, #00d8ff 0%, #0088cc 100%);
  color: #fff;
  border: none;
  padding: 10px 55px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  border-radius: 6px;
  transition: all 0.3s;
  letter-spacing: 2px;
  box-shadow: 0 2px 12px rgba(0, 216, 255, 0.3);
}

.confirm-btn:hover {
  background: linear-gradient(135deg, #00e8ff 0%, #0099dd 100%);
  box-shadow: 0 4px 18px rgba(0, 216, 255, 0.5);
  transform: translateY(-1px);
}

.confirm-btn.green {
  background-color: #00c853;
  color: #fff;
}

.confirm-btn.green:hover {
  background-color: #00a344;
}

.text-btn {
  background: rgba(0, 216, 255, 0.06);
  color: #a8d8ea;
  border: 1px solid rgba(0, 216, 255, 0.25);
  padding: 9px 24px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  border-radius: 6px;
  transition: all 0.3s;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  letter-spacing: 0.5px;
}

.text-btn:hover {
  background-color: rgba(0, 216, 255, 0.15);
  border-color: #00d8ff;
  color: #00d8ff;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 216, 255, 0.2);
}

.text-btn .el-icon-link {
  font-size: 16px;
}

.chart-actions {
  position: absolute;
  right: 20px;
  top: 10px;
  display: flex;
  gap: 10px;
  z-index: 99;
}

.action-btn {
  background-color: transparent;
  color: #fff;
  border: none;
  padding: 6px 15px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  border-radius: 4px;
  /* transition: background-color 0.3s; */
}

.action-btn:hover {
  background-color: #00a8cc;
}

.action-btn.icon-only {
  padding: 6px 10px;
  font-size: 16px;
  line-height: 1;
}

.table-content {
  width: 100%;
  height: 300px;
  overflow-y: auto;
  margin-top: 50px;
}

.table-content table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}

.table-content th,
.table-content td {
  border: 1px solid #555;
  padding: 8px;
  text-align: center;
  color: #fff;
}

.table-content th {
  background-color: #006e99;
  font-weight: 600;
}

.table-content tbody tr:nth-child(even) {
  background-color: rgba(0, 216, 255, 0.1);
}

.table-content tbody tr:hover {
  background-color: rgba(0, 216, 255, 0.2);
}

.el-input__inner {
  background-color: transparent !important;
  color: #00d8ff !important;
  border-color: #00d8ff !important;
}

.el-icon-date {
  color: #00d8ff !important;
}

.myheaderBtnBox {
  height: 30px;
  width: 500px;
  position: absolute;
  right: 0;
  top: 5vh;
  z-index: 999;
  display: flex;
  justify-content: space-between;
}

.myheaderBtnitem {
  height: 30px;
  width: 150px;
  color: #07D8FE;
  border: none;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  border-radius: 4px;
  line-height: 30px;
  margin-left: 15px;
}

.myheaderBtnitem:hover {
  color: #fff;
  text-shadow: 0 0 10px rgba(7, 216, 254, 0.8);
}

.warning-banner {
  position: fixed;
  top: 80px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2000;
  max-width: 600px;
  width: 90%;
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 16px;
  border-radius: 8px;
  backdrop-filter: blur(8px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  animation: warningSlideIn 0.3s ease-out;
}

.warning-orange {
  background: rgba(230, 162, 60, 0.2);
  border: 1px solid rgba(230, 162, 60, 0.5);
}

.warning-orange .warning-icon i {
  color: #e6a23c;
}

.warning-red {
  background: rgba(245, 108, 108, 0.2);
  border: 1px solid rgba(245, 108, 108, 0.5);
}

.warning-red .warning-icon i {
  color: #f56c6c;
}

.warning-yellow {
  background: rgba(231, 200, 42, 0.2);
  border: 1px solid rgba(231, 200, 42, 0.5);
}

.warning-yellow .warning-icon i {
  color: #e7c82a;
}

.warning-blue {
  background: rgba(64, 158, 255, 0.2);
  border: 1px solid rgba(64, 158, 255, 0.5);
}

.warning-blue .warning-icon i {
  color: #409eff;
}

.warning-icon {
  flex-shrink: 0;
  padding-top: 2px;
}

.warning-icon i {
  font-size: 20px;
}

.warning-content {
  flex: 1;
  min-width: 0;
}

.warning-headline {
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 2px;
}

.warning-desc {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.75);
  line-height: 1.4;
}

.warning-close {
  flex-shrink: 0;
  cursor: pointer;
  padding: 2px;
  opacity: 0.5;
  transition: opacity 0.2s;
}

.warning-close:hover {
  opacity: 1;
}

.warning-close i {
  color: #fff;
  font-size: 14px;
}

@keyframes warningSlideIn {
  from { opacity: 0; transform: translateX(30px); }
  to { opacity: 1; transform: translateX(0); }
}

.user-menu {
  display: flex;
  align-items: center;
  justify-content: center;
}

.user-menu i {
  margin-right: 5px;
  font-size: 16px;
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  border-radius: 8px;
}

.loading-spinner {
  text-align: center;
  color: #00d8ff;
}

.loading-spinner i {
  font-size: 48px;
  animation: rotate 2s linear infinite;
}

.loading-spinner p {
  margin-top: 12px;
  font-size: 16px;
  letter-spacing: 2px;
}

@keyframes rotate {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.map-container {
  position: relative;
}

.map-header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
  margin-bottom: 5px;
}

.map-header-row .chart-title {
  position: static;
  margin-bottom: 0;
}

.map-header-controls {
  display: flex;
  align-items: center;
  gap: 8px;
}

.map-opacity-slider {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 10px 6px 10px;
  background: rgba(0, 20, 40, 0.6);
  border-top: 1px solid rgba(0, 216, 255, 0.2);
}

.map-opacity-slider .opacity-label {
  font-size: 11px;
  color: #ccc;
  white-space: nowrap;
}

.map-opacity-slider .opacity-range {
  flex: 1;
  height: 4px;
  cursor: pointer;
  accent-color: #00d8ff;
}

.map-opacity-slider .opacity-value {
  font-size: 11px;
  color: #00d8ff;
  min-width: 36px;
  text-align: right;
}

.map-mode-select {
  width: 100px;
  z-index: 999;
}

.map-date-select {
  width: 150px;
  z-index: 999;
}

.map-chart {
  flex: 1;
  width: 100%;
  min-height: 250px;
  border-radius: 4px;
  overflow: hidden;
}

.map-chart >>> .leaflet-control-attribution {
  display: none;
}

.map-chart >>> .dashLine {
  stroke-dasharray: 5 5;
  fill: none;
  stroke-width: 2;
}

.map-chart >>> .dashLine path {
  stroke-dasharray: 5 5;
}

.fullscreen-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.85);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.fullscreen-chart-container {
  width: 95vw;
  height: 90vh;
  background: rgba(10, 20, 40, 0.95);
  border: 2px solid rgba(0, 216, 255, 0.5);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 0 40px rgba(0, 216, 255, 0.3);
}

.fullscreen-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 25px;
  border-bottom: 1px solid rgba(0, 216, 255, 0.2);
}

.fullscreen-title {
  color: #00d8ff;
  font-size: 22px;
  font-weight: 700;
}

.fullscreen-close-btn {
  background: rgba(0, 216, 255, 0.15);
  color: #00d8ff;
  border: 1px solid rgba(0, 216, 255, 0.4);
  padding: 8px 22px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  border-radius: 6px;
  transition: all 0.3s;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.fullscreen-close-btn:hover {
  background: rgba(0, 216, 255, 0.3);
  border-color: #00d8ff;
  box-shadow: 0 0 15px rgba(0, 216, 255, 0.4);
}

.fullscreen-chart-content {
  flex: 1;
  width: 100%;
}

.fullscreen-map-container {
  width: 95vw;
  height: 90vh;
  background: rgba(10, 20, 40, 0.95);
  border: 2px solid rgba(0, 216, 255, 0.5);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 0 40px rgba(0, 216, 255, 0.3);
}

.fullscreen-map-content {
  flex: 1;
  width: 100%;
}

.copyright-footer {
  text-align: center;
  padding: 8px 0 12px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.4);
  letter-spacing: 1px;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
}
</style>
